import { useContext } from "react";
import { SocketContext } from "./SocketContext";

export default function useSocketContext() {
    const socketContext = useContext(SocketContext);
    return {socket: socketContext.socket};
}